import { IRootState } from '..'

export const getUser = (state: IRootState, id: string) =>
  state.userState.users.find(user => user.id === id)
